module.exports = __webpack_public_path__ + "img/qrCode_zhTc.57f45347.png";